<app-option-bar [type]="moduleType" [details]="moduleDetails"></app-option-bar>
<div class="container-fluid testcase-wrapper">
  <div class="content-wrapper">
    <div class="inner-nav">
      <app-left-menu [details]="moduleDetails" [type]="moduleType"></app-left-menu>
    </div>

    <div class="inner-content collapsed">
      <div class="row mb-3">
        <div class="col-6 assoc-section">
          <div class="common-section testcase-list-sec">
            <div class="">
              <div class="d-flex justify-content-between title">
                <h4>Associate testsuite(s)</h4>
                <span class="float-right"> 
                  <button class="btn btn-sm text-white" style="background-color: #0288d1;" (click)="showSrch = !showSrch">
                    <i class="fas fa-filter clickable filter-instruction " ngbTooltip="Filter" id="filter" placement="left"></i>
                  </button>
                    <a [routerLink]='"/testsuite/new"' target="_blank"><button class="btn btn-sm ml-2 text-white" style="background-color: #0288d1;" ngbTooltip="Create Testsuite">Create</button></a>
              </span>
                </div>
            </div>
            <div class="extra-box mt-3" *ngIf="showSrch">
              <form [formGroup]="testSuiteSearchForm" (ngSubmit)="loadTestSuites()" class="common-form-style">
                <div class="row m-0 align-items-center">
                  <label>Filters :</label>
                  <input type="text" class="form-control form-control-sm" id="srchkeyword" placeholder="Search Keyword" formControlName="keyword" />
                  <ng-select class="custom-style" id="project-filter" [items]="myProjectsList" bindLabel="name" bindValue="id" placeholder="Select project(s)" [searchable]="true" [multiple]="true" formControlName="projectIds">
                    <ng-template ng-option-tmp let-item="item">
                      <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
                    </ng-template>
                  </ng-select>
                  <div class="ml-auto button-container mr-3">
                    <button type="submit" class="btn btn-primary btn-sm mr-2">Search</button>
                    <button type="cancel" class="btn btn-warning btn-sm" (click)="clearFilter()">Clear</button>
                  </div>
                </div>
              </form>
            </div>

            <table class="table mt-3 endpointlist-table">
              <thead style="background-color: rgb(49, 49, 48);color: whitesmoke;">
                <tr>
                  <th class="col-endpoint">Testsuite</th>
                  <th class="col-action text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="testSuiteList?.length === 0">
                  <td colspan="2" class="text-center">No data found</td>
                </tr>
                <tr *ngFor="let testsuite of testSuiteList" [class.active]="isAssociated(testsuite.id)">
                  <td class="col-endpoint" title="{{testsuite.name}}">
                    <div class="endpoint-container">
                      <a class="mr-1" target="_blank" [routerLink]="['/testsuite', testsuite.id]">
                        <i class="fas fa-link"></i>
                      </a>
                      <i class="fas fa-award text-success" ngbTooltip="Certified" *ngIf="testsuite.certified"></i>
                      <span class="endpoint-text">{{testsuite.name}}</span>
                    </div>
                  </td>
                  <td class="col-action text-right">
                    <i class="fas fa-plus-circle clickable text-primary" (click)="addToAssocTestSuite(testsuite)"
                      title="Add to testSuite list" style="font-size: 16px;"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row pagination-sec mt-2">
            <div class="col"> <b>Total results : </b>{{collectionSize || 0}} </div>
            <div class="col-1 remove-padding">
              <ng-select (change)="onSizeChange()" [clearable]="false" [(ngModel)]="pageSize">
                <ng-option [value]="15">15</ng-option>
                <ng-option [value]="25">25</ng-option>
                <ng-option [value]="50">50</ng-option>
                <ng-option [value]="100">100</ng-option>
              </ng-select>
            </div>
            <div class="col-md-auto">
              <ngb-pagination class="d-flex justify-content-end" [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [(page)]="page" [rotate]="true" (pageChange)="onPageChange($event)"></ngb-pagination>
            </div>
          </div>
        </div>

        <div class="col-6 assoc-section selected-testcase">
          <div class="d-flex justify-content-between title mt-2"><h4>Mastersuite testsuites</h4></div>
          <div class="mt-3 assoc-section">
            <table class="table endpointlist-table draggable-table" cdkDropList (cdkDropListDropped)="drop($event)">
              <thead style="background-color: rgb(49, 49, 48); color: whitesmoke;">
                <tr>
                  <th class="col-endpoint">Testsuite</th>
                  <th class="col-action text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="assocTestSuites?.length === 0">
                  <td colspan="2" class="text-center"> <i class='fas fa-arrow-left text-primary mr-1'></i> Please select a testsuite
                    from the list</td>
                </tr>
                <tr *ngFor="let testsuite of assocTestSuites" cdkDrag>
                  <td class="col-endpoint" title="{{ testsuite.testSuiteName }}">
                    <div class="endpoint-container">
                      <a class="mr-1" target="_blank" [routerLink]="['/testsuite', testsuite.testSuiteId]">
                        <i class="fas fa-link"></i>
                      </a>
                      <i class="fas fa-award text-success" ngbTooltip="Certified" *ngIf="testsuite.certified"></i>
                      <span class="endpoint-text">{{ testsuite.testSuiteName }}</span>
                    </div>
                  </td>
                  <td class="col-action text-right">
                    <i [ngClass]="{ 'text-danger': !testsuite.active }" class="fas fa-ban clickable ml-1 mr-2"
                      (click)="testsuite.active = !testsuite.active" title="Disable"></i>
                    <i class="fas fa-trash-alt text-danger clickable ml-1 mr-1" (click)="removeAssocTestSuite(testsuite)"
                      title="Remove"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-right mt-3">
              <button type="button" class="btn relay-btn relay-createbtn" [ngClass]="isMSEdit ?'update':'create'" (click)="saveEditMasterSuite()">{{isMSEdit ? 'Update' : 'Create'}}</button>
              <button type="button" class="btn relay-btn cancel" [routerLink]="['/mastersuite/',  masterSuiteId]" *ngIf="masterSuiteId">Cancel</button>
              <button type="button" class="btn relay-btn cancel" [routerLink]="['/mastersuite/']" [queryParams]="{page:1,size:15}" *ngIf="!masterSuiteId">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
